import { TooltipContent } from "@/components/ui/tooltip";

import { InfoIcon } from "lucide-react";

import { TooltipTrigger } from "@/components/ui/tooltip";

import { Tooltip } from "@/components/ui/tooltip";
import { ExportType } from "@/lib/auth/export/export-types";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

type ExportTypeSelectorProps = {
  selectedType: ExportType;
  setSelectedType: (type: ExportType) => void;
};

export const ExportTypeSelector = ({
  selectedType,
  setSelectedType,
}: ExportTypeSelectorProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex p-1 rounded-xl bg-gray-100">
      <button
        className={cn(
          "flex items-center gap-1 px-3 py-1 rounded-lg",
          selectedType === "partial" && "bg-white",
        )}
        onClick={() => setSelectedType("partial")}
      >
        {t("export.partial").replace(" ", "\u00A0")}
        <Tooltip>
          <TooltipTrigger>
            <InfoIcon className="w-4 h-4" />
          </TooltipTrigger>
          <TooltipContent variant="action" className="px-3">
            <span className="text-gray-300 text-sm font-medium">
              {t("export.partial.tooltip")}
            </span>
          </TooltipContent>
        </Tooltip>
      </button>
      <button
        className={`flex items-center gap-1 px-3 py-1 rounded-lg ${selectedType === "full" ? "bg-white" : ""}`}
        onClick={() => setSelectedType("full")}
      >
        {t("export.full").replace(" ", "\u00A0")}
        <Tooltip>
          <TooltipTrigger>
            <InfoIcon className="w-4 h-4" />
          </TooltipTrigger>
          <TooltipContent variant="action" className="px-3">
            <span className="text-gray-300 text-sm font-medium">
              {t("export.full.tooltip")}
            </span>
          </TooltipContent>
        </Tooltip>
      </button>
    </div>
  );
};
